import { render, staticRenderFns } from "./SubfolderTableRow.vue?vue&type=template&id=63577f30&"
import script from "./SubfolderTableRow.vue?vue&type=script&lang=ts&"
export * from "./SubfolderTableRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports